<template>
<div id="denominators-main">
  <div v-if="surveillance != null">
    <action-bar id="action-bar" :actions="shortcuts" v-sticky></action-bar>

    <div class="container-cap">
      <router-view :config="config"
                   :state="state"
                   type="denominators"
                   :sheets="[]"
                   :surveillance="surveillance" ref="subpage"/>
    </div>
  </div>
  <span v-for="(s, i) in shortcuts"
        :key="`sheet-main-shortcut-${i}`"
        v-shortkey.once.prevent="s.keys"
        @shortkey="s.action(s.param)">
  </span>
</div>
</template>
<script>
import actionBar from '@/sui/components/actionBar'

export default {
  name: 'sheet-denominators',

  props: {
    config: {
      type: Object,
      required: true
    },

    surveillance: {
      type: Object
    }
  },

  data: function () {
    return {
      state: {
        list: false,
        refreshing: false,
        tabbed: true
      },
      shortcuts: [
        { keys: { h: ['f1'] }, action: this.toggleHelp },
        {
          keys: { h: ['f3'] },
          action: this.save,
          keyText: `<span class="key">F3</span>`,
          icon: 'floppy-save',
          nav: () => true,
          tooltip: () => '<strong>Enregistrer</strong> la fiche',
          text: 'Enregistrer'
        }
      ]
    }
  },

  computed: {
    type: function () {
      return this.$route.params.st
    },

    routePrefix: function () {
      if (this.surveillance == null) {
        return ''
      }

      const year = this.surveillance.year
      const id = this.surveillance.id
      const t = this.type
      return `/establishments/${year}/${id}/denominators/${t}`
    }
  },

  watch: {
    routePrefix: function () {
      this.state.list = this.$route.query.start === 'list'
    },

    surveillance: function (s) {
      this.state.tabbed = s.year === 2019
    }
  },

  mounted: function () {
    if (this.surveillance != null) {
      this.state.tabbed = this.surveillance.year === 2019
    }
  },

  methods: {
    edit: function (s) {
      this.state.list = false
      this.$router.push(`${this.routePrefix}/${s.id}/edit`)
    },

    save: function () {
      this.$refs.subpage.save()
    }
  },

  beforeRouteUpdate: function (to, from, next) {
    if (this.$refs.subpage) {
      this.$refs.subpage.checkRoute(to, from, next)
    } else {
      next()
    }
  },

  beforeRouteLeave: function (to, from, next) {
    if (this.$refs.subpage) {
      this.$refs.subpage.checkRoute(to, from, next)
    } else {
      next()
    }
  },

  components: {
    'action-bar': actionBar
  }
}
</script>
<style scoped lang="less">
@import '~variables';
#denominators-main {
    .btn {
        margin-right: 1rem;
        margin-left: 1rem;
    }
    padding-bottom: 18rem;
  #action-bar {
    @media (min-width: 0) and (max-width: @screen-sm-max) {
      margin-left: 23rem;
    }
  }

}
</style>
